import DownloadCSVMenuButton, {
    downloadTypes,
} from 'components/Button/DownloadCSVMenuButton';
import downloadImage from 'utils/downloadImage';
import { downloadPopularityTimeSeriesAsCSV } from 'utils/formatCSV';

function DownloadPopularityTimeSeriesButton({
    filename,
    csvFilename,
    imageTitle,
    data,
    wrapperRef,
    ...props
}) {
    const resolvedCsvFilename = csvFilename ?? `${filename} time series`;
    const resolvedImageTitle = imageTitle ?? filename;
    return (
        <DownloadCSVMenuButton
            options={[
                {
                    mixpanelMeta: { label: 'time series csv' },
                    children: 'Time Series CSV',
                    onClick: () =>
                        downloadPopularityTimeSeriesAsCSV(
                            resolvedCsvFilename,
                            [{ tsData: data }],
                            { nonNumericColumns: ['date'] },
                        ),
                    downloadType: downloadTypes.CSV,
                    key: 'time series csv',
                },
                {
                    mixpanelMeta: { label: 'time series image' },
                    children: 'Time Series Image',
                    onClick: () =>
                        downloadImage(wrapperRef.current, {
                            title: resolvedImageTitle,
                            filename: resolvedCsvFilename,
                        }),
                    downloadType: downloadTypes.IMAGE,
                    key: 'time series image',
                },
            ]}
            isDisabled={!data}
            mixpanelMeta={{ contentKey: 'TimeSeriesChart' }}
            {...props}
        />
    );
}

export default DownloadPopularityTimeSeriesButton;
